module.exports = __webpack_public_path__ + "static/img/showroom1.5b66ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom1.png
// module id = zW/3
// module chunks = 2